import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "./ui/card";

const TransactionForm = ({ apps, onSubmit }) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const getLocalDate = () => {
    const date = new Date();
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset()); // Adjust for timezone
    return date.toISOString().split('T')[0];
  };

  const [formData, setFormData] = useState({
    appId: '',
    type: 'deposit',
    amount: '',
    date: getLocalDate(),
    notes: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.appId || !formData.amount) {
      alert('Please select an app and enter an amount');
      return;
    }

    const amount = parseFloat(formData.amount);
    const processedAmount = Math.abs(amount);

    const submissionData = {
      ...formData,
      amount: processedAmount
    };

    onSubmit(submissionData);

    setFormData({
      appId: '',
      type: 'deposit',
      amount: '',
      date: new Date().toISOString().split('T')[0],
      notes: ''
    });
  };

  return (
    <Card style={{ backgroundColor: '#FFFFFF' }}>
      <CardHeader>
        <CardTitle>Add Transaction</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Casino</label>
              <select
                name="appId"
                value={formData.appId}
                onChange={handleChange}
                className="w-full p-2 border rounded bg-white"
                required
              >
                <option value="">Select Casino</option>
                {apps.map((app) => (
                  <option key={app._id} value={app._id}>
                    {app.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Transaction Type</label>
              <select
                name="type"
                value={formData.type}
                onChange={handleChange}
                className="w-full p-2 border rounded bg-white"
              >
                <option value="deposit">Deposit</option>
                <option value="withdraw">Withdraw</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Amount</label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
                className="w-full p-2 border rounded bg-white"
                placeholder="Enter amount"
                required
                step="0.01"
                min="0"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Date</label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                className="w-full p-2 border rounded bg-white"
              />
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-2">Notes</label>
              <textarea
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                className="w-full p-2 border rounded bg-white"
                placeholder="Optional"
                rows="3"
              />
            </div>
          </div>

          <button
            type="submit"
            className="w-full bg-blue-500 text-white p-3 rounded hover:bg-blue-600 transition-colors font-medium"
          >
            Add Transaction
          </button>
        </form>
      </CardContent>
    </Card>
  );
};

export default TransactionForm;